import { useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faFileCirclePlus,
    faFilePen,
    faUserGear,
    faUserPlus,faTasks,
    faRightFromBracket,
    faSortNumericUp,
    faUserLock,
    faListCheck,
    faFlagCheckered,
    faFileAlt,
    faClock,
    faQuestionCircle,
    faCode,
    faFileText,
    faCodeBranch,
    faFileCode,
    faArchive
} from "@fortawesome/free-solid-svg-icons"
import { useNavigate, Link, useLocation, useParams } from 'react-router-dom'
import { useSendLogoutMutation } from '../features/auth/authApiSlice'
import getFilePath from '../utils/getFilePath'
import useAuth from '../hooks/useAuth'
import PulseLoader from 'react-spinners/PulseLoader'
import GroupFilter from './GroupFilter'
import { useDispatch, useSelector } from 'react-redux'
import { changeFormatCode, selectSettings } from '../features/settings/settingsSlice'
import { changeArchiveState, selectArchive } from '../features/settings/archiveSlice'
const DASH_REGEX = /^\/dash(\/)?$/
const ACTIONS_REGEX = /^\/dash\/actions(\/)?$/
const TASKS_REGEX = /^\/dash\/tasks(\/)?$/
const USERS_REGEX = /^\/dash\/users(\/)?$/

const DashHeader = () => {
    const { isTeacher, isAdmin, isStudent, image } = useAuth()
    const {formatCode} = useSelector(selectSettings)
    const {archive} = useSelector(selectArchive)
    const dispatch = useDispatch()
    const {groupId, type} = useParams()
    const navigate = useNavigate()
    const { pathname } = useLocation()

    const [sendLogout, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useSendLogoutMutation()

    useEffect(() => {
        if (isSuccess) navigate('/')
    }, [isSuccess, navigate])

    const onNewActionClicked = () => navigate(`/${type}/${groupId}/actions/new`)
    const onNewUserClicked = () => navigate(`/${type}/${groupId}/users/new`)
    const onActionsClicked = () => navigate(`/${type}/${groupId}/actions`)
    const onUsersClicked = () => navigate(`/${type}/${groupId}/users`)
    const onTasksClicked = () => navigate(`/${type}/${groupId}/tasks`)
    const onReportsClicked = () => (isTeacher || isAdmin)? navigate(`/${type}/${groupId}/reports`):navigate(`/${type}/${groupId}/my-reports`)
    const onQuestionClicked = () => (isTeacher || isAdmin)? navigate(`/${type}/${groupId}/question-sets`):navigate(`/${type}/${groupId}/user-questions`)
    let dashClass = null
    if (!DASH_REGEX.test(pathname) && !ACTIONS_REGEX.test(pathname) && !USERS_REGEX.test(pathname)) {
        dashClass = "dash-header__container--small"
    }
    let newActionButton = null
    if (ACTIONS_REGEX.test(pathname)) {
        newActionButton = (
            <button
                className="icon-button"
                title="New Action"
                onClick={onNewActionClicked}
            >
                <FontAwesomeIcon icon={faFileCirclePlus} />
            </button>
        )
    }

    let newUserButton = null
    if (isTeacher || isAdmin) {
        newUserButton = (
            <button
                className="icon-button"
                title="New User"
                onClick={onNewUserClicked}
            >
                <FontAwesomeIcon icon={faUserPlus} />
            </button>
        )
    }

    let userButton = null
    if (isTeacher || isAdmin) {
            userButton = (
                <button
                    className="icon-button"
                    title="Users"
                    onClick={onUsersClicked}
                >
                    <FontAwesomeIcon icon={faUserGear} />
                </button>
            )
      
    }

       const  reportButton = (
                <button
                    className="icon-button"
                    title="דוחות"
                    onClick={onReportsClicked}
                >
                    <FontAwesomeIcon icon={faFileAlt} />
                </button>
            )
      
  

    let actionsButton = null
    if (!ACTIONS_REGEX.test(pathname) && pathname.includes('/dash')) {
        actionsButton = (
            <button
                className="icon-button"
                title="Actions"
                onClick={onActionsClicked}
            >
                <FontAwesomeIcon icon={faFilePen} />
            </button>
        )
    }

    let tasksButton  = (
            <button
                className="icon-button"
                title="משימות"
                onClick={onTasksClicked}
            >
                <FontAwesomeIcon icon={faTasks} />
            </button>
        )
   
    const questionsButton =(
        <button
        className="icon-button"
        title="שאלונים"
        onClick={onQuestionClicked}
    >
        <FontAwesomeIcon icon={faQuestionCircle} />
    </button>
    )


    const logoutButton = (
        <button
            className="icon-button"
            title="יציאה"
            onClick={sendLogout}
        >
            <FontAwesomeIcon icon={faRightFromBracket} />
        </button>
    )

    const gradesButton = (
        <button
            className="icon-button"
            title="ציונים"
            onClick={()=>{ isStudent? navigate(`/${type}/${groupId}/my-grades`): navigate(`/${type}/${groupId}/grades`)}}
        >
            <FontAwesomeIcon icon={faSortNumericUp} />
        </button>
    )
    const profileButton = (
        <button
            className="icon-button"
            title="פרופיל משתמש"
            onClick={()=>{  navigate(`/${type}/${groupId}/profile`)}}
        >
            <FontAwesomeIcon icon={faUserLock} />
        </button>
    )
    let presenceButton = null
        presenceButton = (
            <button
                className="icon-button"
                title="נוכחות"
                onClick={()=>{ isStudent?  navigate(`/${type}/${groupId}/my-presence`): navigate(`/${type}/${groupId}/lessons`) }}
            >
                <FontAwesomeIcon icon={faClock} />
            </button>
        )
  
        const formatCodeBtn = (<button
            className="icon-button"
            title="פורמט קוד"
            onClick={()=>{dispatch(changeFormatCode(!formatCode))}}
        >
          {(formatCode)?  <FontAwesomeIcon  icon={faFileCode} /> :  <FontAwesomeIcon icon={faCode} />}   
        </button> )

const archiveButton = (isAdmin?<button
    className="icon-button"
    title="ארכיון "
    onClick={()=>{navigate(`/${type==="dash"? "archive": "dash"}/${groupId}/`)}}
>
  {(archive)?  <FontAwesomeIcon color={"red"}  icon={faArchive} /> :  <FontAwesomeIcon  icon={faArchive} />}   
</button> :"")
    const errClass = isError ? "errmsg" : "offscreen"

    let buttonContent
    if (isLoading) {
        buttonContent = <PulseLoader color={"#FFF"} />
    } else {
        buttonContent = (
            <>
            {tasksButton}
                {/* {newActionButton}
               {newUserButton}
                {actionsButton}*/}
                {presenceButton}
               {reportButton}
               {questionsButton}
                {gradesButton}
                {userButton} 
                {/* {formatCodeBtn} */}
                {archiveButton}
                {profileButton}
                {logoutButton}
            </>
        )
    }

    const content = (
        <>
            <p className={errClass}>{error?.data?.message}</p>
            <header className="dash-header">
                <div className={`dash-header__container ${dashClass}`}>
                    {image && <div className='profile-image' style={{backgroundImage:`url(${getFilePath(image)})`}}></div>}
                    <Link className='logo-link' to={`/${type}/${groupId}/`}>
                        <h1 className="dash-header__title">geshtop-Exercise</h1>
                    </Link>
                    <GroupFilter />
                    <nav className="dash-header__nav">
                        {buttonContent} 
                    </nav>
                   
                </div>
            </header>
        </>
    )

    return content
}
export default DashHeader